module.exports = __webpack_public_path__ + "21b046fb64a1366066b678f300e266fc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-11.png
// module id = 3238
// module chunks = 0